<template>
  <div class="website-form">
    <el-card>
      <div slot="header">
        <span>{{ isEdit ? '编辑网站' : '新增网站' }}</span>
      </div>

      <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="max-width:560px">
        <el-form-item label="网站名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入网站名称" />
        </el-form-item>
        <el-form-item label="网站域名" prop="domain">
          <el-input v-model="form.domain" placeholder="例如：www.example.com" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用" />
        </el-form-item>

        <el-divider content-position="left">封禁接口配置（可选）</el-divider>
        <el-form-item label="封禁接口URL">
          <el-input v-model="form.ban_api_url" placeholder="例如：https://web.cn-acv.com/ban/receive" />
        </el-form-item>
        <el-form-item label="接口Token">
          <el-input v-model="form.ban_api_token" placeholder="与目标网站约定的认证Token" show-password />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">保存</el-button>
          <el-button @click="$router.back()">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 创建成功后显示追踪信息 -->
    <el-card v-if="createdInfo.tracking_code" class="created-card">
      <div slot="header">
        <i class="el-icon-success" style="color:#67C23A"></i>
        <span style="margin-left:8px">网站创建成功</span>
      </div>
      <el-descriptions :column="1" border>
        <el-descriptions-item label="追踪代码">{{ createdInfo.tracking_code }}</el-descriptions-item>
        <el-descriptions-item label="JS链接">{{ createdInfo.tracker_url }}</el-descriptions-item>
        <el-descriptions-item label="嵌入代码">
          <div class="embed-code-block">
            <code>{{ createdInfo.embed_code }}</code>
            <el-button type="primary" size="mini" icon="el-icon-document-copy" @click="copyEmbed">复制</el-button>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <el-alert
        title="使用说明"
        type="info"
        :closable="false"
        show-icon
        style="margin-top:16px"
      >
        <template slot="default">
          <div>1. 将上述「嵌入代码」复制到需要统计的网站页面中</div>
          <div>2. 放置在 <code>&lt;head&gt;</code> 标签内或 <code>&lt;/body&gt;</code> 之前均可</div>
          <div>3. 代码已包含 <code>async defer</code> 属性，不会阻塞页面渲染</div>
          <div>4. 有用户访问该网站时，数据会自动采集到本平台</div>
        </template>
      </el-alert>
      <div style="margin-top:16px;text-align:center">
        <el-button type="primary" @click="$router.push('/websites')">返回网站列表</el-button>
        <el-button @click="$router.push('/website/stats/' + createdInfo.id)">查看统计</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { websiteApi } from '../api';

export default {
  name: 'WebsiteForm',
  data() {
    return {
      isEdit: false,
      form: { name: '', domain: '', status: 1, ban_api_url: '', ban_api_token: '' },
      rules: {
        name: [{ required: true, message: '请输入网站名称', trigger: 'blur' }],
        domain: [{ required: true, message: '请输入网站域名', trigger: 'blur' }]
      },
      createdInfo: {}
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.isEdit = true;
      this.loadDetail();
    }
  },
  methods: {
    async loadDetail() {
      try {
        const res = await websiteApi.detail(this.$route.params.id);
        if (res.code === 0) {
          this.form = {
            id: res.data.id,
            name: res.data.name,
            domain: res.data.domain,
            status: res.data.status,
            ban_api_url: res.data.ban_api_url || '',
            ban_api_token: res.data.ban_api_token || '',
          };
        }
      } catch (e) {
        this.$message.error('加载失败');
      }
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        try {
          if (this.isEdit) {
            const res = await websiteApi.update(this.form);
            if (res.code === 0) {
              this.$message.success('更新成功');
              this.$router.push('/websites');
            } else {
              this.$message.error(res.msg);
            }
          } else {
            const res = await websiteApi.create(this.form);
            if (res.code === 0) {
              this.createdInfo = res.data;
              this.$message.success('创建成功');
            } else {
              this.$message.error(res.msg);
            }
          }
        } catch (e) {
          this.$message.error('操作失败');
        }
      });
    },
    copyEmbed() {
      const text = this.createdInfo.embed_code;
      const input = document.createElement('textarea');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); this.$message.success('已复制到剪贴板'); }
      catch (e) { this.$message.error('复制失败'); }
      document.body.removeChild(input);
    }
  }
};
</script>

<style scoped>
.created-card {
  margin-top: 16px;
}

.embed-code-block {
  display: flex;
  align-items: center;
  gap: 12px;
}

.embed-code-block code {
  background: #f5f7fa;
  padding: 6px 10px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
  word-break: break-all;
  flex: 1;
}
</style>
